import { useContext, useEffect, useState } from "react";
import { format } from "react-string-format";
import { useConfirm } from "material-ui-confirm";
import { Context } from "../../../utils/context";
import { Strings } from "../../../assets/res/en";
import {
  programEndPoints,
  groupsEndPoints,
  merchantsEndPoints,
  profilesEndPoints,
} from "../../../utils/endpoints";
import programDataColumn from "../../../dataColumns/programDataColumn";
import useTableIcons from "../../useTableIcons";
import useCommonMenus from "../common/useCommonMenus";
import { modules } from "../../../utils/config";

export default function useProgram({onQRCodeSelected}) {
  const { axios, authData, permissions } = useContext(Context);
  const authToken = `Bearer ${authData.token}`;
  const [userPermission, setUserPermission] = useState({});
  const [programs, setPrograms] = useState([]);
  const [sprograms, setSearchPrograms] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { columns, sytlingOptions } = programDataColumn({onQRCodeSelected});
  const confirm = useConfirm();
  const [groupsMenus, setGroupMenus] = useState([]);
  const [locationMenus, setLocationMenus] = useState([]);
  const [searchData, setSearchData] = useState({
    sDescription: "",
    sGroup: "",
    sLocation: "",
  });
  const [filters, setFilters] = useState([]);
  const { tableIcons } = useTableIcons();
  const { profileMenus } = useCommonMenus(axios);

  //check permission changes
  useEffect(() => {
    if (permissions && permissions.length > 0) {
      let usrPermission = permissions.find(
        (p) => p.moduleId === modules.programs.id
      );
      //console.log(usrPermission)
      setUserPermission(usrPermission);
    }
    
  }, [permissions]);

  const updateQRProgram = async(id_program, data) => {
    //setIsLoading(true);
    let response = null
    try {
      response = await axios.put(`/program/${id_program}`, data, { headers: { Authorization: authToken } })
    } catch (error) {
      console.log('ERROR: Update QR Program', error)
    }
    return response
  };

  

  const getAllPrograms = () => {
    setIsLoading(true);
    axios
      .get(programEndPoints.getAll, { headers: { Authorization: authToken } })
      .then((res) => {
        if (res.data.success) {
          const { data } = res.data;
          setPrograms(data);
          setSearchPrograms(data);
        }
      })
      .catch((err) => err)
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    axios
      .get(groupsEndPoints.getAll, {
        headers: { Authorization: authToken },
      })
      .then((res) => {
        if (res.data.success) {
          const { data } = res.data;
          const groupItems = data
            .map((g) => ({
              text: g.description,
              val: g.idGroup,
            }))
            .sort((a, b) => (a.text ?? "").localeCompare(b.text ?? ""));

          setGroupMenus([
            {
              text: Strings.SEARCH_CASINO_GROUP,
              val: "",
            },
            {
              text: Strings.NO_GROUP,
              val: 0,
            },
            ...groupItems,
          ]);
        }
      });
  }, []);
  useEffect(() => {
    setLocationMenus([
      {
        text: Strings.SEARCH_CASINO_LOCATION,
        val: "",
      },
      {
        text: Strings.NO_LOCATION,
        val: 0,
      },
    ]);
    setSearchData((prevData) => ({
      ...prevData,
      sLocation: "",
    }));
    if (searchData.sGroup > 0) {
      let merchantByGroupId = `${merchantsEndPoints.getMerchantByGroupID}/${searchData.sGroup}`;
      axios
        .get(merchantByGroupId, { headers: { Authorization: authToken } })
        .then((res) => {
          if (res.status === 200) {
            const { data } = res.data;
            const locationItems = data
              .map((g) => ({
                text: g.description,
                val: g.idMerchant,
              }))
              .sort((a, b) => (a.text ?? "").localeCompare(b.text ?? ""));
            setLocationMenus((prevData) => [...prevData, ...locationItems]);
          }
        })
        .catch((err) => err);
    }
  }, [searchData.sGroup]);
  const clearFilter = ({ name }, nfilters, searchData) => {
    let filteredData = sprograms;
    switch (name) {
      case "sDescription":
        if (searchData["sGroup"] !== "" && searchData["sGroup"] >= 0)
          filteredData = filteredData.filter(
            (u) => u.idGroup === searchData["sGroup"]
          );
        if (searchData["sLocation"] !== "" && searchData["sLocation"] >= 0)
          filteredData = filteredData.filter(
            (u) => u.idMerchant === searchData["sLocation"]
          );
        break;
      case "sGroup":
        if (
          searchData["sDescription"] &&
          searchData["sDescription"].trim() !== ""
        )
          filteredData = filteredData.filter((u) =>
            u.description
              .toLowerCase()
              .includes(searchData["sDescription"].trim().toLowerCase())
          );
        const finr = nfilters.filter(
          (f) => f.name !== "sGroup" || f.name !== "sLocation"
        );
        const fir = nfilters.find((f) => f.name === "sLocation");
        fir.value = "";
        setFilters([fir, ...finr]);
        setSearchData((prevData) => ({
          ...prevData,
          sLocation: "",
        }));
        break;
      case "sLocation":
        if (
          searchData["sDescription"] &&
          searchData["sDescription"].trim() !== ""
        )
          filteredData = filteredData.filter((u) =>
            u.description
              .toLowerCase()
              .includes(searchData["sDescription"].trim().toLowerCase())
          );
        if (searchData["sGroup"] !== "" && searchData["sGroup"] >= 0)
          filteredData = filteredData.filter(
            (u) => u.idGroup === searchData["sGroup"]
          );
        break;
      default:
        break;
    }
    const filterItemNotToRemove = nfilters.filter((f) => f.name !== name);
    const filterItemToRemove = nfilters.find((f) => f.name === name);
    filterItemToRemove.value = "";
    setFilters([filterItemToRemove, ...filterItemNotToRemove]);
    setSearchData((prevData) => ({
      ...prevData,
      [name]: "",
    }));
    setPrograms(filteredData);
  };
  const resetFilterData = (nfilters) => {
    setFilters(nfilters.map((item) => ({ ...item, value: "" })));
    setSearchData({
      sDescription: "",
      sGroup: "",
      sLocation: "",
    });
    getAllPrograms();
  };
  const handleChange = (name, value) => {
    setSearchData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSearch = () => {
    setFilters([
      {
        name: "sDescription",
        value: searchData["sDescription"],
        remove: clearFilter,
      },
      {
        name: "sGroup",
        value:
          searchData["sGroup"] === ""
            ? ""
            : groupsMenus.find((g) => g.val === searchData["sGroup"]).text,
        remove: clearFilter,
      },
      {
        name: "sLocation",
        value:
          searchData["sLocation"] === ""
            ? ""
            : locationMenus.find((l) => l.val === searchData["sLocation"]).text,
        remove: clearFilter,
      },
      {
        name: "clear",
        isClearAll: true,
        clearAll: resetFilterData,
      },
    ]);
    let filteredData = sprograms;
    if (
      searchData["sDescription"].trim() === "" &&
      (searchData["sGroup"] === "" || searchData["sGroup"] < 0) &&
      (searchData["sLocation"] === "" || searchData["sLocation"] < 0)
    ) {
      resetFilterData(filters);
    } else {
      if (
        searchData["sDescription"] &&
        searchData["sDescription"].trim() !== ""
      )
        filteredData = filteredData.filter((u) =>
          u.description
            .toLowerCase()
            .includes(searchData["sDescription"].trim().toLowerCase())
        );
      if (searchData["sGroup"] !== "" && searchData["sGroup"] >= 0)
        filteredData = filteredData.filter(
          (u) => u.idGroup === searchData["sGroup"]
        );
      if (searchData["sLocation"] !== "" && searchData["sLocation"] >= 0)
        filteredData = filteredData.filter(
          (u) => u.idMerchant === searchData["sLocation"]
        );
      setPrograms(filteredData);
    }
  };

  const searchOptions = {
    title: Strings.SEARCH_PROGRAM_TITLE,
    spacing: 2,
    searchItems: [
      {
        name: "sDescription",
        label: Strings.COLUMN_PROGRAM_DESCRIPTION,
        type: "search",
        defaultValue: searchData["sDescription"],
        onChange: handleChange,
      },
      {
        name: "sGroup",
        label: Strings.SEARCH_CASINO_GROUP,
        isSelect: true,
        menuItems: groupsMenus,
        defaultValue: searchData["sGroup"],
        onChange: handleChange,
      },
      {
        name: "sLocation",
        label: Strings.SEARCH_CASINO_LOCATION,
        isSelect: true,
        menuItems: locationMenus,
        defaultValue: searchData["sLocation"],
        onChange: handleChange,
      },
    ],
    handleSearch,
  };

  return {
    programs,
    isLoading,
    searchOptions,
    getAllPrograms,
    columns,
    sytlingOptions,
    userPermission,
    sprograms,
    filters,
    searchData,
    updateQRProgram
  };
}
